'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  menu = [];

  isCollapsed = true;

  constructor(Auth, ngToast, $http, Build) {
    'ngInject';
    this._Build = Build;
    this.$http = $http;
    this._$ngToast = ngToast;
    this.isNotFreight = Auth.isNotFreightSync;
    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
  }

  trigger() {
    console.log('test');
    this._Build.trigger()
      .then(res => {
        console.log('Result', res);
        this._$ngToast.info({dismissButton: true, content: 'Build triggered successfully. Please wait at least 3 minutes before building again.'});
      })
      .catch(err => {
        console.log('Error', err);
        this._$ngToast.danger({dismissButton: true, content: 'Build trigger failed.'});
      });
  }

}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.pug'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js